export default "__VITE_ASSET__D8DWml5b__"